import { render } from "./dialogImportExcel.vue?vue&type=template&id=0b81e412"
import script from "./dialogImportExcel.vue?vue&type=script&lang=js"
export * from "./dialogImportExcel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__